import { CarrierSettings } from 'shared/settings/CarrierSettingsAPI';

interface GettingStartedStep {
  status?: string;
}

interface GettingStartedSteps {
  tour_create_or_import_load?: GettingStartedStep | null;
  get_to_know_ctms?: GettingStartedStep | null;
  tour_slb_search?: GettingStartedStep | null;
  explore_supercard?: GettingStartedStep | null;
}

interface GettingStartedCompletedParams {
  data?: { steps?: GettingStartedSteps | null } | null;
  verificationStatus?: CarrierSettings['carrier']['verification_status'];
  isSuperCardEnabled: boolean;
  hasSettings: boolean;
}

export function isGettingStartedCompleted({
  data,
  verificationStatus,
  isSuperCardEnabled,
  hasSettings,
}: GettingStartedCompletedParams): boolean {
  if (!data || !hasSettings) {
    return false;
  }

  const { steps } = data;
  const isSubmitted = verificationStatus !== 'not_submitted';
  const exploreSuperCardStep = steps?.explore_supercard;
  // Require Explore SuperCard only when the toggle is on and the dispatcher
  // has the key. Toggle-off and missing-key carriers keep the existing rule.
  const isExploreSuperCardRequired =
    isSuperCardEnabled && exploreSuperCardStep != null;

  return (
    isSubmitted &&
    steps?.tour_create_or_import_load?.status === 'started' &&
    steps?.get_to_know_ctms?.status === 'started' &&
    steps?.tour_slb_search?.status === 'started' &&
    (!isExploreSuperCardRequired || exploreSuperCardStep.status === 'started')
  );
}
